var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlannerInfoCopyStart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5461_3238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.30283 9.97274C9.55383 10.4647 9.35851 11.067 8.86656 11.318C8.37461 11.569 7.77233 11.3737 7.52132 10.8817C6.73968 9.34977 7.02198 7.47045 8.25691 6.23552L10.3782 4.1142C11.9403 2.5521 14.473 2.5521 16.0351 4.1142C17.5972 5.6763 17.5972 8.20896 16.0351 9.77105C15.6446 10.1616 15.0114 10.1616 14.6209 9.77105C14.2303 9.38053 14.2303 8.74736 14.6209 8.35684C15.4019 7.57579 15.4019 6.30946 14.6209 5.52841C13.8398 4.74736 12.5735 4.74736 11.7924 5.52841L9.67112 7.64973C9.05361 8.26725 8.91237 9.20748 9.30283 9.97274ZM10.8494 10.1736C10.5984 9.68167 10.7937 9.07938 11.2857 8.82838C11.7776 8.57737 12.3799 8.7727 12.6309 9.26464C13.4125 10.7966 13.1302 12.6759 11.8953 13.9108L9.77398 16.0322C8.21189 17.5943 5.67923 17.5943 4.11713 16.0322C2.55503 14.4701 2.55503 11.9374 4.11713 10.3753C4.50765 9.98478 5.14082 9.98478 5.53134 10.3753C5.92187 10.7658 5.92187 11.399 5.53134 11.7895C4.75029 12.5706 4.75029 13.8369 5.53134 14.6179C6.31239 15.399 7.57872 15.399 8.35977 14.6179L10.4811 12.4966C11.0986 11.8791 11.2398 10.9389 10.8494 10.1736Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5461_3238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlannerInfoCopyStart);
export default __webpack_public_path__ + "static/media/planner_info_copy_start.521b1643bac6cf0223f8c1323d7ca7ef.svg";
export { ForwardRef as ReactComponent };